<style>
  #BtnDiv {
    position: fixed;
    bottom: 25px;
    left: 25px;
    background: #282a39b0;
    padding: 10px;
    border-radius: 5px;
  }
</style>

<div [hidden]="Show_History_View>0" class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم رسید امانت</h5>

    <button type="button" *ngIf="Letter_Form_Id=='0'" (click)="openModal_Customer(templateCustomer)"
      class="btn btn-warning" style="margin-left: 5px;"> جستجوی مشتری <i class="fa fa-vcard"></i> </button>


    <br />
    <br />

    <div *ngIf="Data_Seleted_Customer.id>0">

      <form>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> شماره نامه </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input type="text" class="form-control" name="name" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> تحویل دهنده </label>
            <input type="text" class="form-control" name="Delivery" [(ngModel)]="Delivery" placeholder="اینجا تایپ کنید ..." />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> توضیحات </label>
            <input type="text" class="form-control" name="Dsc" [(ngModel)]="Dsc" placeholder="اینجا تایپ کنید ..." />
          </div>
        </div>

      </form>

      <br />
      <hr />
      <br />

      <div>

        <h5> پیام های نامه </h5>

        <br />

        <form *ngIf="canEditMainForm" [formGroup]="MailMessageForm" (submit)="MailMessageForm_Submit()">

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> پیام نامه </label>
              <select class="custom-select" formControlName="mailmessage_id">
                <option value="0">انتخاب کنید</option>
                <option *ngFor="let item of DataList_MailMessage" [value]="item.id">{{item.title}}</option>
              </select>
            </div>
          </div>

          <button type="submit" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i>
            افزودن پیام </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="FormAdded_MailMessage.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>پیام نامه</th>
                <th *ngIf="canEditMainForm">امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of FormAdded_MailMessage">
                <td>{{FormAdded_MailMessage.indexOf(item)+1}}</td>
                <td>{{item.title}}</td>
                <td style="cursor: pointer;" *ngIf="canEditMainForm">
                  <a style="cursor: pointer;" (click)="MailMessageForm_Delete(FormAdded_MailMessage.indexOf(item))"
                    class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                </td>
              </tr>
            </tbody>
          </table>




        </div>

        <br />
        <br />

      </div>


      <br />
      <hr />
      <br />

      <h5> تجهیزات </h5>

      <br />
      <br />
      <form *ngIf="canEditMainForm" [formGroup]="DeviceForm" (submit)="DeviceForm_Submit()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_Device(templateDevice)"
                class="btn btn-warning left"> انتخاب دستگاه <i class="fa  fa-simplybuilt"></i> </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Device_Record.title}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">تعداد</label>
            <input formControlName="tedad" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_DeviceForm_tedad().valid && get_DeviceForm_tedad().touched"
              class="form-text text-muted MyErrorRedColor">تعداد را وارد نمائید.</small>
          </div>

        </div>
        <div class="row">

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">توضیحات </label>
            <textarea type="text" formControlName="dsc" placeholder="اینجا تایپ کنید ..." class="form-control"></textarea>
          </div>

        </div>
        <button type="submit" [disabled]="!DeviceForm.valid" class="btn btn-success" style="margin-left: 5px;"><i
            class="fa  fa-plus-circle"></i> افزودن تجهیز </button>
      </form>


      <br />
      <br />

      <div class="table-responsive" *ngIf="DeviceFormList.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام تجهیز</th>
              <th>تعداد</th>
              <th>توضیحات</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DeviceFormList">

              <tr>
                <td>{{DeviceFormList.indexOf(item)+1}}</td>
                <td>{{item.device_name}}</td>
                <td>{{item.tedad}}</td>
                <td>{{item.dsc}}</td>
                <td *ngIf="canEditMainForm && !item.dsc_bazgast">
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="OpenImageDialog(templateImageForm,item)"
                          class="dropdown-item"><i class="fa fa-cloud-upload"></i> فایل های ضمیمه </a>

                        <a style="cursor: pointer;"
                          (click)="DeleteDeviceFormList_Modal(templateRemoveDevice,DeviceFormList.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>

                        <a *ngIf="item.id>0" style="cursor: pointer;" (click)="OpenBazgasht(templateBazgasht,item)"
                          class="dropdown-item"><i class="fa fa-recycle"></i> بازگشت دستگاه </a>
                      </div>
                    </div>
                  </div>
                </td>
                <td *ngIf="item.dsc_bazgast">
                  <p>{{item.dsc_bazgast}}</p>
                </td>
              </tr>

              <tr *ngIf="item.file.length>0">
                <td colspan="5">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #3e399b; color: white;">
                      <tr>
                        <th>#</th>
                        <th>فایل</th>

                        <th *ngIf="canEditMainForm && !item.dsc_bazgast">امکانات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let itemFile of item.file">

                        <td>{{item.file.indexOf(itemFile)+1}}</td>
                        <td>

                          <a target="_blank" *ngIf="itemFile.includes('.pdf')"
                            href="{{BaseURlFile}}File/Letter/{{itemFile}}" class="btn btn-success"><i
                              class="fa fa-file-pdf-o"></i> PDF </a>


                          <img *ngIf="!itemFile.includes('.pdf')" (click)="openModal(templateImage,itemFile)"
                            style="width: 150px;cursor: zoom-in;" src="{{BaseURlFile}}File/Letter/{{itemFile}}" />
                        </td>
                        <td *ngIf="canEditMainForm && !item.dsc_bazgast">
                          <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                            <div class="btn-group" role="group">
                              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                امکانات
                              </button>
                              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                <a style="cursor: pointer;"
                                  (click)="UploadImageSrc_List_Delete(item.file.indexOf(itemFile),item)"
                                  class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                              </div>
                            </div>
                          </div>
                        </td>

                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

            </ng-container>




          </tbody>
        </table>
      </div>


    </div>


    <br />
    <br />

    <div id="BtnDiv">

      <img *ngIf="Data_Seleted_Customer.id>0 && InProccessing" src="assets/Loading.gif" style="width: 25px;" />

      <ng-container *ngFor="let item of Data_List_Order">

        <button *ngIf="item.submit && !InProccessing" type="button" (click)="OpenOrderDialog(templateOrder,item)"
          [disabled]="DeviceFormList.length==0" [class]="item.cls" style="margin-left: 5px;"> <i
            [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="item.hasRefer && !item.submit && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [disabled]="DeviceFormList.length==0" [class]="item.cls"
          style="margin-left: 5px;"><i [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="!item.hasRefer && !item.submit && !item.copy && !InProccessing" type="button"
          [disabled]="DeviceFormList.length==0" (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls"
          style="margin-left: 5px;"> <i [class]="item.icon"></i> {{item.title}} </button>

      </ng-container>

      <button *ngIf="has_calibration_customer_order && !InProccessing"  type="button" class="btn btn-info" style="margin-left: 5px;"> 
        <i class="fa fa-info-circle"></i> درخواست فراخدمات
      </button>

      <button *ngIf="!InProccessing" (click)="NewForm()" type="button" class="btn btn-info" style="margin-left: 5px;">
        <i class="fa fa-recycle"></i> فرم رسید امانت جدید </button>
      <button *ngIf="Letter_Form_Id>0 && !InProccessing && canReviewDetail" (click)="ReadHistory_Letter()" type="button"
        class="btn btn-warning" style="margin-left: 5px;"> <i class="fa fa-file-text"></i> جزئیات نامه </button>
      <button *ngIf="Letter_Form_Id>0 && !InProccessing"
        (click)="OpenNoteDialog(templateComment)" type="button" class="btn btn-success" style="margin-left: 5px;"> <i
          class=" fa fa-sticky-note-o"></i> ثبت نظر </button>
      <a target="_blank" *ngIf="canDownloadPDF && Letter_Form_Id>0 && !InProccessing && canReviewDetail"
        href="{{BaseUrl}}{{Letter_Form_Id}}" style="margin-left: 5px;" class="btn btn-info"><i
          class="fa fa-file-pdf-o"></i> Pdf </a>

    </div>


    <br />
    <br />



  </div>

</div>

<div *ngIf="Show_History_View==1" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">جزئیات نامه '{{Letter_Form_Code}}'</h5>
        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">تاریخچه ارجاع</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                aria-controls="months" aria-selected="true">پیوست نامه</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#flowchart" role="tab"
                aria-controls="months" aria-selected="true">فلوچارت ارجاع</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerHistory [DataList_History]="DataList_History"></app-LetterRequestCustomerHistory>
          </div>

        </div>
        <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerPeyvast [canOpenPeyvast]="canOpenPeyvast" [DataList_Peyvast]="DataList_Peyvast"></app-LetterRequestCustomerPeyvast>

          </div>
        </div>
        <div class="tab-pane fade show" id="flowchart" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div>
              <app-LetterRequestCustomerTreeHistory [DataList_History]="DataList_History">
              </app-LetterRequestCustomerTreeHistory>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
    </button>

  </div>



</div>




<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات مشتری </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد مشتری بهفا</th>
              <th>نام مشتری</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات دستگاه ها </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> نام دستگاه </label>
          <input type="text" class="form-control" (keyup)="ReadData_Device_KeySearch()"
            [(ngModel)]="Search_Name_Device_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام دستگاه</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device
            | paginate
                    : {
                        id: 'DataList_Device',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Device).length
                      }">
              <td>{{DataList_Device.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_Device_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingDevice" type="button" (click)="ReadData_Device()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> شماره نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>شماره نامه <b>'{{Letter_Form_Code}}'</b></p>
  </div>
  <div class="modal-body" *ngIf="canShowSendSMS">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>نام و نام خانوادگی</th>
            <th>سمت</th>
            <th>شماره تلفن همراه</th>
            <th>توضیحات</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Karshnash">
            <td>{{DataList_Karshnash.indexOf(item)+1}}</td>
            <td>
              <span *ngIf="item.sex==1">آقای</span>
              <span *ngIf="item.sex==0">خانم</span>
              {{item.fname}} {{item.lname}}
            </td>
            <td>{{item.semat}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.dsc}}</td>
            <td>
              <button type="button" *ngIf="!item.del" class="btn btn-danger"
                (click)="Change_Selected_Of_Karshnash(item)">عدم انتخاب</button>
              <button type="button" *ngIf="item.del" class="btn btn-info" (click)="Change_Selected_Of_Karshnash(item)">
                انتخاب</button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">

    <button type="button" *ngIf="canShowSendSMS" class="btn btn-success" (click)="SendSMS()">ارسال پیامک</button>
    <button type="button" *ngIf="canShowSendSMS" class="btn btn-warning" (click)="SendSMS_NoMatch()">ارسال پیامک عدم تطابق</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateOrder>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Selected_Order_Operation.title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Order.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12" *ngIf="Selected_Order_Operation.hasRefer || Selected_Order_Operation.submit">
        <label for="exampleInputEmail1">گیرنده</label>
        <select class="custom-select" [(ngModel)]="SelectedLetterRole">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of Data_list_LetterRole" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="SubmitAddNewLetter_Co(templateCode,Selected_Order_Operation)"> ارسال و ثبت </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Order.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateImageForm>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> فرم بارگذاری فایل </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ImageForm.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group col-md-6">
      <label for="exampleInputEmail1">
        فایل/های ضمیمه
        <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
            class="fa  fa-times-rectangle"></i> </button>
      </label>
      <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
      <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
        class="form-control" placeholder="اینجا تایپ کنید ...">
    </div>
  </div>
  <div class="modal-footer">

    <button *ngIf="canEditMainForm" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمیمه </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ImageForm.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateBazgasht>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> تایید بازگشت دستگاه رسید امانت </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Bazgasht.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input type="text" class="form-control" [(ngModel)]="Dsc_Bazgasht" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="DeleteBazgashtDevice(0)"> ثبت اطلاعات </button>
    <button type="button" class="btn btn-info" (click)="DeleteBazgashtDevice(1)"> ثبت اطلاعات (ارسال پیامک) </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Bazgasht.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> ثبت نظر جدید برای مشتری '{{Data_Seleted_Customer.name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Note.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">شرح</label>
        <textarea type="text" class="form-control" [(ngModel)]="Note_Dsc" placeholder="اینجا تایپ کنید ...">
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="SubmitNote()">
      ارسال و ثبت </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Note.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateRemoveDevice>
  <div class="modal-header">
     <h4 class="modal-title pull-left">تایید حذف دستگاه '{{DeleteDeviceFormList_Record.device_name}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeleteDeviceFormList.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="DeleteDeviceFormList()"> حذف دستگاه <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_DeleteDeviceFormList.hide()">بستن</button>
  </div>
</ng-template>
